export default __webpack_public_path__ + "static/media/setupBudgetManually.2c6bf18c.png";